<aside
  [ngClass]="{'hidden': !showFilters, 'block': showFilters}"
>
  <div class="bg-white p-3 sm:p-4 rounded-lg shadow-md">
    <!-- Categories -->
    <div class="mb-4 sm:mb-6">
      <h3 class="text-base sm:text-lg font-semibold mb-1 sm:mb-2 border-b pb-1 sm:pb-2">
        <app-page-title [title]="category || 'Eau de Parfum'" [children]="[{ title: category }]"></app-page-title>
        {{ category || 'Eau de Parfum' }}
      </h3>
      <p class="text-xs sm:text-sm text-gray-600 mb-1 sm:mb-2">{{ productsLength }} produits</p>
      <div *ngIf="families" class="space-y-1 sm:space-y-2">
        <label *ngFor="let famille of families" class="flex items-center">
          <input
            type="checkbox"
            [(ngModel)]="famille.selected"
            (change)="onFilterChange()"
            class="mr-2 h-4 w-4 sm:h-5 sm:w-5 accent-gold"
          >
          <span class="text-xs sm:text-sm">{{ famille.name }} </span>
<!--
          <div *ngIf="famille?.sousFamilles && famille.selected" class="space-y-1 sm:space-y-2">
            <label *ngFor="let sf of famille.sousFamilles" class="flex items-center">
              <input
                type="checkbox"
                [(ngModel)]="sf.selected"
                (change)="onFilterChange()"
                class="mr-2 h-4 w-4 sm:h-5 sm:w-5 accent-gold"
              >
              <span class="text-xs sm:text-sm">{{ sf.sousFamille }} </span>
            </label>
          </div>
-->
        </label>
      </div>
    </div>

    <!-- Discounts -->
<!--
    <div class="mb-4 sm:mb-6">
      <h3 class="text-base sm:text-lg font-semibold mb-1 sm:mb-2 border-b pb-1 sm:pb-2">Remises</h3>
      <div class="space-y-1 sm:space-y-2">
        <label *ngFor="let discount of discounts" class="flex items-center">
          <input
            type="checkbox"
            [(ngModel)]="discount.selected"
            (change)="onFilterChange()"
            class="mr-2 h-4 w-4 sm:h-5 sm:w-5 accent-gold"
          >
          <span class="text-xs sm:text-sm">{{ discount.name }} ({{ discount.count || 0 }})</span>
        </label>
      </div>
    </div>
-->

    <!-- Brands -->
    <div class="mb-4 sm:mb-6">
      <h3 class="text-base sm:text-lg font-serif font-semibold mb-1 sm:mb-2 border-b-2 border-gold pb-1 sm:pb-2 shadow-sm">
        Marque
      </h3>
      <div class="relative mb-1 sm:mb-2">
        <input
          type="text"
          placeholder="Rechercher une marque"
          (input)="filterBrands($event.target.value)"
          class="w-full p-1 sm:p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gold focus:border-transparent transition-all duration-300 text-xs sm:text-sm"
        >
      </div>
      <div
        class="space-y-1 sm:space-y-2 max-h-32 sm:max-h-48 md:max-h-64 overflow-y-auto border border-gray-200 rounded-lg p-1 sm:p-2 bg-white shadow-inner"
      >
        <label
          *ngFor="let brand of filteredBrands"
          class="flex items-center hover:bg-gray-50 p-1 sm:p-2 rounded transition-colors duration-300"
        >
          <input
            type="checkbox"
            [(ngModel)]="brand.selected"
            (change)="onFilterChange()"
            class="mr-2 h-4 w-4 sm:h-5 sm:w-5 accent-gold"
          >
          <span class="text-xs sm:text-sm font-medium text-gray-700">{{ brand.name }} ({{ brand.count || 0 }})</span>
        </label>
      </div>
    </div>
  </div>
</aside>
